import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import 'hammerjs';


import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

/*if (environment.production) {
  document.write('<script async src="https://www.googletagmanager.com/gtag/js?id=UA-45299324-1"></script>' +
  + '<script>window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}' +
  + 'gtag("j", new Date());gtag("config", "UA-45299324-1");</script>');
}*/

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
